<template>
    <div>
        <b-col cols="12">
            <h2>{{ $t('tests.self-evaluation-tests.title')}}</h2>
        </b-col>
		<b-row class="neu-cards-ctn" cols="1" cols-xl="4">
            <PatientPanelServiceBlock visible id="diagram-id" title="opensalud ScoreCard" :action="() => { $router.push('tests/opensalud-scorecard')}" :img="`/static-appopensalud/img/icons/morillas-svg-icons/primary/radar-chart.svg`" :backgroundColor="BLUE_COLOUR" :textAndIconColor="WHITE_COLOUR" only360Users/>
              <PatientPanelServiceBlock visible id="physical-tests-id" :title="$t(`tests.${PHYSICAL_HEALTH_TESTS.name}`)" :action="() => { $router.push(`tests/block/${PHYSICAL_HEALTH_TESTS.name}`)}" :img="`/static-appopensalud/img/icons/morillas-svg-icons/primary/radar-chart.svg`">
              <template v-slot:icon>
                    <span class="chart-container"><progress-chart :testList="PHYSICAL_HEALTH_TESTS.tests"/></span>
              </template>
            </PatientPanelServiceBlock>
            <PatientPanelServiceBlock visible id="mental-tests-id" :title="$t(`tests.${MENTAL_HEALTH_TESTS.name}`)" :action="() => { $router.push(`tests/block/${MENTAL_HEALTH_TESTS.name}`)}" :img="`/static-appopensalud/img/icons/morillas-svg-icons/primary/radar-chart.svg`">
              <template v-slot:icon>
                    <span class="chart-container"><progress-chart :testList="MENTAL_HEALTH_TESTS.tests"/></span>
              </template>
            </PatientPanelServiceBlock>
            
            <PatientPanelServiceBlock visible :key="test.id" v-for="test in tests" :id="test.id" :title="test.title" :action="() => test.action()" :img="test.img" :only360Users="test.only360Users"/>
            <PatientPanelServiceBlock :id="freedomAndFlowBlock.id" :title="freedomAndFlowBlock.title" :description="freedomAndFlowBlock.description" :img="freedomAndFlowBlock.img" :action="freedomAndFlowBlock.action" :enabled="freedomAndFlowBlock.enabled" :visible="freedomAndFlowBlock.visible" :active="freedomAndFlowBlock.active" :key="freedomAndFlowBlock.id" :iconSize="freedomAndFlowBlock.iconSize"/>
        </b-row>
    </div>
</template>

<script>
import PatientPanelServiceBlock from '@/components/PatientPanelServiceBlock'
import BackButton from '@/components/base/buttons/BackButton'
import companyServicesMixin from '@/mixins/companyServices.mixin'
import { FREEDOM_AND_FLOW_SERVICE, PHYSICAL_HEALTH_TESTS, MENTAL_HEALTH_TESTS, ONLY_360_USERS_TESTS } from '@/constants/patientServices'
import { BProgress } from 'bootstrap-vue'
import { testsToDisplayOnBlocks } from '@/helpers/tests.helpers'
import ProgressChart from '@/components/charts/ProgressChart.vue'
import { BLUE_COLOUR, WHITE_COLOUR } from '@/constants/colours'

export default {
  name: 'SelfEvaluationTestMenu',
  mixins: [companyServicesMixin],
  components: {
    PatientPanelServiceBlock,
    BackButton,
    BProgress,
    ProgressChart
  },
  props: {
    companyServices: {
      type: Array,
      required: false,
      default () {
        return this.$store.state.session.user && this.$store.state.session.user.activeCompanyServices ? this.$store.state.session.user.activeCompanyServices : []
      }
    }
  },
  data () {
    return {
      PHYSICAL_HEALTH_TESTS,
      MENTAL_HEALTH_TESTS,
      BLUE_COLOUR,
      WHITE_COLOUR
    }
  },
  methods: {
    testIsOnlyFor360Users (test) {
      return ONLY_360_USERS_TESTS.includes(test)
    }
  },
  computed: {
    tests () {
      return testsToDisplayOnBlocks(this.companyServices, this)
    },
    freedomAndFlowBlock () {
      const _this = this
      const service = this.companyServices ? this.companyServices.find(service => service.id === FREEDOM_AND_FLOW_SERVICE) : null
      return {
        id: FREEDOM_AND_FLOW_SERVICE,
        title: this.$t('patient-panel.wellbeing-score'),
        description: this.$t('patient-panel.wellbeing-score-description'),
        img: '/static-appopensalud/img/icons/morillas-svg-icons/primary/bars.svg',
        action () {
          _this.goToFreedomAndFlow()
        },
        active: service && service.active,
        enabled: service && service.enabled
      }
    }
  }
}
</script>

<style lang="scss" scoped>
 @import "static-appopensalud/css/public/views/360.scss";
	
	.patient-panel-block {
		@include desktop {
			margin-bottom: 2rem;
		}
	}
  .chart-container {
    display: block;
    width: 100%;
    height: 85px;
  }

.neu-card {
  min-height: contents;

  @include media(desktop-sm, tablets, mobile) {
    margin-bottom: 2rem;

    >* {
      text-align: center;
    }

    .info-btn {
      position: absolute;
      right: 20px;
      top: 10px;
    }

    &:not(.description-mobile-visible) {
      min-height: 65px;
    }

    &.description-mobile-visible {
      min-height: 200px;
    }
  }
}

.neu-card-title {
  vertical-align: middle;
}

p {
  @include media(mobile, tablets) {
    margin: {
      top: 0 !important;
      bottom: 0 !important;
    }
  }
}

@include media(tablets, mobile) {
  .neu-cards-ctn {
    padding: {
      top: 1rem;
      left: 0rem !important;
      right: 0rem !important;
    }
  }

  .neu-card {
    text-align: left;
    max-width: 260px;
    margin: 0 auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/webapp/patient/SelfEvaluationTestMenu.vue